import { useEffect } from 'react';
import { SITE_URL } from '../data/site';
interface SeoProps {
  title: string;
  description: string;
  path: string;
  /** Keep the page out of search results (private / post-evaluation pages). */
  noindex?: boolean;
}
function upsertMeta(selector: string, attribute: string, value: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, value);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}
function upsertCanonical(href: string) {
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}
export function Seo({
  title,
  description,
  path,
  noindex = false
}: SeoProps) {
  useEffect(() => {
    const canonical = `${SITE_URL}${path}`;
    document.title = title;
    upsertMeta('meta[name="description"]', 'name', 'description', description);
    upsertMeta('meta[property="og:title"]', 'property', 'og:title', title);
    upsertMeta('meta[property="og:description"]', 'property', 'og:description', description);
    upsertMeta('meta[property="og:url"]', 'property', 'og:url', canonical);
    upsertMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
    upsertMeta('meta[name="robots"]', 'name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    upsertCanonical(canonical);
  }, [title, description, path, noindex]);
  return null;
}